import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Clock } from '@phosphor-icons/react';
import moment from 'moment';

import {
  AddDocumentCertificateDetailsBoxStyled,
  AddDocumentDetailsBoxStyled,
  AddYourDocumentsCertificateStatusBoxStyled,
  ElectedBenefitTextStyled,
} from './AddYourDocumentsCardStyled';
import { UploadDocumentsDrawer } from './UploadDocumentsDrawer';
import { DocumentRequest } from 'enrollment/features/ToDoList/types';

interface RequestedDocumentsType {
  cardDetails: DocumentRequest;
  cardName: string;
  missingDocTypes?: string[];
}

export const RequestedDocuments = ({
  cardDetails,
  cardName,
  missingDocTypes,
}: RequestedDocumentsType) => {
  const { t } = useTranslation('pages.enrollmentAddYourDocuments');

  const electedBenefitValue = cardDetails.benefits_subject_to_termination
    ? cardDetails.benefits_subject_to_termination?.join(', ')
    : cardDetails.benefit_name;

  const formattedTerminateDate = moment(
    cardDetails.terminate_coverage_on
  ).format('MMMM DD, YYYY');

  return (
    <AddYourDocumentsCertificateStatusBoxStyled>
      <AddDocumentCertificateDetailsBoxStyled>
        <Typography variant="body1" gutterBottom>
          {t('uploadDocs')}
        </Typography>
        {electedBenefitValue && (
          <ElectedBenefitTextStyled variant="body2" gutterBottom>
            {t('ElectedBenefit')}: {electedBenefitValue}
          </ElectedBenefitTextStyled>
        )}
        {cardDetails.terminate_coverage_on && (
          <>
            <Clock size={16} className="mr-2" />
            <Typography variant="overline" gutterBottom>
              {t('By') + formattedTerminateDate}
            </Typography>
          </>
        )}
      </AddDocumentCertificateDetailsBoxStyled>
      <AddDocumentDetailsBoxStyled>
        <UploadDocumentsDrawer
          cardName={cardName}
          id={cardDetails.id}
          termableBenefits={cardDetails.benefits_subject_to_termination}
          benefitName={cardDetails.benefit_name}
          terminateCoverageOn={cardDetails.terminate_coverage_on}
          requestText={cardDetails.request_text}
          documentTypeIds={
            missingDocTypes || cardDetails.org_subscriber_document_type_ids
          }
        />
      </AddDocumentDetailsBoxStyled>
    </AddYourDocumentsCertificateStatusBoxStyled>
  );
};
